import { Button, Tooltip } from "@material-ui/core";
import React, { useEffect, useState } from "react";
import { shallowEqual, useSelector } from "react-redux";
import { Card, CardBody, CardHeader } from "../../_metronic/_partials/controls";
import { getGameById, updateGame } from "../../api/game";
import { getPlanLogStats } from "../../api/plan-log";
import { alertError, alertSuccess } from "../../utils/logger";
import ConfirmDialog from "../components/dialogs/ConfirmDialog";
import RevenueChartPanel from "../components/dashboard/RevenueChartPanel";

function getData(game) {
	let data = [];
	return data;
}

function formatEurFromCents(cents) {
	const n = Number(cents);
	if (!Number.isFinite(n)) return "—";
	return new Intl.NumberFormat("es-ES", {
		style: "currency",
		currency: "EUR",
	}).format(n / 100);
}

export function DashboardPage() {
	const [game, setGame] = useState(null);
	const [active, setActive] = useState(false);
	const [tableData, setTableData] = useState([]);
	const [refresh, setRefresh] = useState(false);
	const [openConfirmDialog, setOpenConfirmDialog] = useState(false);
	const [financeStats, setFinanceStats] = useState(null);
	const user = useSelector(
		(store) => store.authentication?.user,
		shallowEqual
	);
	const isModerator = user?.game ? true : false;

	useEffect(() => {
		let cancelled = false;

		if (isModerator) {
			getGameById(user?.game)
				.then((resGame) => {
					if (cancelled) return;
					if (resGame.status === 200) {
						setGame(resGame.data);
						setActive(resGame.data.active);
						setTableData(getData(resGame.data));
						setRefresh(false);
					}
				})
				.catch((error) => {
					if (cancelled) return;
					alertError({
						error: error,
						customMessage: "Could not get game.",
					});
				});
			return () => {
				cancelled = true;
			};
		}

		getPlanLogStats()
			.then((resStats) => {
				if (cancelled) return;
				if (resStats.status === 200) {
					setFinanceStats(resStats.data);
				} else {
					setFinanceStats(null);
				}
			})
			.catch(() => {
				if (!cancelled) setFinanceStats(null);
			});

		return () => {
			cancelled = true;
		};
	}, [refresh, isModerator, user?.game]);

	function handleGameStatus() {
		setActive((active) => !active);
		setGame({ ...game, active: !active });
		updateGame(game._id, { ...game, active: !active })
			.then((res) => {
				if (res.status === 200) {
					alertSuccess({
						title: "Success!",
						customMessage: !game.active
							? "Game Started"
							: "Game Ended",
					});
				}
			})
			.catch((error) => {
				alertError({
					error: error,
					customMessage: "Could not start the game.",
				});
			});
	}

	return (
		<>
			<Card>
				<CardHeader
					title={
						game?.fullName != null ? game?.fullName : "Statistics"
					}
				/>
				<CardBody>
					<div>
						{!isModerator && (
						<>
						<div className="row justify-content-center">
									<div className="col-12 col-md-4 text-center my-2">
										<div className="card">
											<div className="card-body">
												<h5 className="card-title">
													Usuarios totales
												</h5>
												<div className="contentDash">
													{financeStats != null
														? financeStats.totalUsers
														: "—"}
												</div>
											</div>
										</div>
									</div>
									<div className="col-12 col-md-4 text-center my-2">
										<div className="card">
											<div className="card-body">
												<h5 className="card-title">
													Ganancia de este mes
												</h5>
												<p className="text-muted small mb-1">
													Cobros y renovaciones registrados
													este mes
												</p>
												<div className="contentDash">
													{financeStats != null
														? formatEurFromCents(
																financeStats.revenueThisMonthCents
														  )
														: "—"}
												</div>
											</div>
										</div>
									</div>
									<div className="col-12 col-md-4 text-center my-2">
										<div className="card">
											<div className="card-body">
												<h5 className="card-title">
													Ganancias totales
												</h5>
												<div className="contentDash">
													{financeStats != null
														? formatEurFromCents(
																financeStats.revenueTotalCents
														  )
														: "—"}
												</div>
											</div>
										</div>
									</div>
						</div>
						<div className="row justify-content-center">
							<RevenueChartPanel />
						</div>
						</>
						)}
						{isModerator && (
							<div className="row justify-content-center">
								<div className="col-12 col-md-3 text-center my-4">
									<div class="card blueBorder">
										<div class="card-body">
											<Tooltip title="Start">
												<Button
													onClick={() =>
														setOpenConfirmDialog(
															true
														)
													}
													className="contentDashB"
												>
													{active
														? "End Game"
														: "Start Game"}
												</Button>
											</Tooltip>
										</div>
									</div>
								</div>
							</div>
						)}
					</div>
				</CardBody>
				<ConfirmDialog
					title={`Are you sure you want to ${
						game?.active ? "end" : "start"
					} this game?`}
					open={openConfirmDialog}
					setOpen={setOpenConfirmDialog}
					onConfirm={handleGameStatus}
				/>
			</Card>
		</>
	);
}
